
.iconButton {
    padding: 0 0.25rem;
}

.disabled {
    cursor: not-allowed;
}

.container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  
    border-radius: 8px;
    border: 1px solid var(--static-divider-standard);

    &.invalid {
        border: 1px solid var(--sentiment-text-negative);
    }
}
.container:focus-within {
    border-color: var(--primary-enabled);
}

.container:not(.disabled) {
  background-color: var(--secondary-enabled);
}
